import { HttpClient, HttpHeaders } from '@angular/common/http';
import { OnInit, Component, ViewEncapsulation, ViewChild, ElementRef, ViewContainerRef, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToolbarService, DocumentEditorContainerComponent,
  DocumentEditorComponent, EditorService, SelectionService, SfdtExportService, WordExportService, TextExportService
} from '@syncfusion/ej2-angular-documenteditor';
import { DemoService } from './../../../demo.service';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { MysqlService } from './../../../services/mysql.service';

import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { Observable } from 'rxjs/internal/Observable';


const httpOptions2 = {
  headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded',  })
};

@Component({
  selector: 'app-system-doc-edit',
  templateUrl: './system-doc-edit.component.html',
  styleUrls: ['./system-doc-edit.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [EditorService, SelectionService, SfdtExportService, TextExportService, WordExportService]
})


export class SystemDocEditComponent implements OnInit {


// setup as observable?
@Input() item_id?: Observable<any[]>; // impliments on changes.
@Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
@Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
@Input() item_user_level_id? = '5'; // default to agent just in case
@Input() item_brand_type_id? = '';
@Input() show_buttons? = 'no'; // yes | no
@Input() widget_title? = '';
@Input() widget_size? = 'side'; // side | abstract | full

// doc_id: number;
@Input() doc_id?;


// load/Convert
@ViewChild('document_editor')
 public documentEditor: DocumentEditorComponent;
  selectedFileData: any;
  selectedFileData2: any;
  selectedFileBlob: any;





  constructor(private http: HttpClient,
    private _mysqlService: MysqlService, private route: ActivatedRoute, private router: Router,
    private fileUploader: FileUploaderService, private elem: ElementRef,
    private _demoService: DemoService,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, public gfunc: GlobalFunctionsService
    ) { 

      // if not set check the route.
       if(!this.doc_id){
      this.doc_id = +this.route.snapshot.paramMap.get('doc_id')
      
      }

      console.log('doc id=: ' + this.doc_id);
      
  //   this.http.get(this.gfunc.baseUploadURL + '/test.sfdt', { responseType: 'text' }).subscribe(data => {
  //     console.log('data', data);
  //     this.selectedFileData = data;
  //     //
  // });

    
  }

  ngOnInit() {
   


       // open SFDT text in document editor
       // this.documentEditor.open(this.selectedFileData);


  // As with JSON, use the Fetch API & ES6
// fetch(this.gfunc.baseUploadURL + '/robots.txt')
// .then(response => response.blob())
// .then(data => {
//   // Do something with your data
//   console.log(data);
//   let newData = new Blob([data]);
//   console.log(newData);
// });


  }




// :: Functions 


public onFileOpenClick() :void {
  document.getElementById('open_sfdt').click();
}


fetchSystemFiles() {
return  this.http.get(this.gfunc.baseUploadURL + '/test2.sfdt', { responseType: 'text' }).subscribe(data => {
  console.log('data2 on function...', data);
  this.selectedFileData2 = data;
 // let sfdt: string = data;
 // this.container.documentEditor.open(sfdt);
// this.documentEditor.serverDataBind(this.selectedFileData2);
  //
  this.container.documentEditor.open(this.selectedFileData2);
});


}


onLoadDocxFile() :void {
this.http.get(this.gfunc.baseUploadURL + '/testFileCreated.docx', { responseType: 'text' }).subscribe(data => {
  console.log('data2 on import...', data);
  this.selectedFileData = data;
 // let sfdt: string = data;
 // this.container.documentEditor.open(sfdt);
 this.documentEditor.open(this.selectedFileData);

  //
});
};

onLoadFile() :void {
// document.getElementById('open_sfdt').click();
// run a function to fetch the data first.
this.fetchSystemFiles(); // data file2

this.http.get(this.gfunc.baseUploadURL + '/test3.sfdt', { responseType: 'text'}).subscribe(data => {
  console.log('data2 on import...', data);
  this.selectedFileData = data;
 // let sfdt: string = data;
 // this.container.documentEditor.open(sfdt);
 this.documentEditor.open(this.selectedFileData);

  //
});






// this.http.get(this.gfunc.baseUploadURL + 's/test2.sfdt', { responseType: 'text' }).subscribe(data => {
//   console.log('data2 on import...', data);
//   this.selectedFileData2 = data;
//  // let sfdt: string = data;
//  // this.container.documentEditor.open(sfdt);
//  this.container.documentEditor.open(this.selectedFileData2);
//   //
// });

console.log('Loading data ss text...' + this.selectedFileData);
// this.documentEditor.serverDataBind(this.selectedFileData);

// this.documentEditor.open(this.selectedFileData);
// this.container.documentEditor.open(this.selectedFileData2);

// this.documentEditor.serverDataBind(this.selectedFileData);
}



onLoadServerFile() :void {
  // document.getElementById('open_sfdt').click();
  // run a function to fetch the data first.
  this.fetchSystemFiles(); // data file2
  
  this.http.get(this.gfunc.baseUploadURL + '/testFileCreated.sfdt', { responseType: 'text' }).subscribe(data => {
    console.log('data2 on import...', data);
    this.selectedFileData = data;
   // let sfdt: string = data;
   // this.container.documentEditor.open(sfdt);
   this.documentEditor.open(this.selectedFileData);
  
    //
  });

  }




public onFileChange(e: any) :void {
   if (e.target.files[0]) {
      let file = e.target.files[0];
      if (file.name.substr(file.name.lastIndexOf('.')) !== '.sfdt') {
          this.loadFile(file);
      }
  }
}

public loadFile(file: File): void {
  let ajax: XMLHttpRequest = new XMLHttpRequest();
  ajax.open('POST', this.gfunc.sopDocxServerURL, true);
  ajax.onreadystatechange = () => {
      if (ajax.readyState === 4) {
          if (ajax.status === 200 || ajax.status === 304) {
              // open SFDT text in document editor
              this.documentEditor.open(ajax.responseText);
          }
      }
  }
  let formData: FormData = new FormData();
  formData.append('files', file);
  ajax.send(formData);
}


public loadDoxFile(): void {
let ajax: XMLHttpRequest = new XMLHttpRequest();
ajax.open('POST', this.gfunc.sopDocxServerURL, true);
ajax.onreadystatechange = () => {
    if (ajax.readyState === 4) {
        if (ajax.status === 200 || ajax.status === 304) {
            // open SFDT text in document editor
            this.documentEditor.open(ajax.responseText);
        }
    }
}
let formData: FormData = new FormData();
// this.http.get(this.gfunc.baseUploadURL + '/template.docx', { responseType: 'blob' }).subscribe(data => {
  this.http.get(this.gfunc.baseUploadURL + '/testFileCreated.docx', { responseType: 'blob' }).subscribe(data => {

 // console.log('data2 on import...', data);
  this.selectedFileBlob = data;
 // let sfdt: string = data;
 // this.container.documentEditor.open(sfdt);
 //this.documentEditor.open(this.selectedFileBlob);

  //
});

formData.append('files', this.selectedFileBlob);
ajax.send(formData);
}



// Save as blob

public saveAsBlobDocx() :void {
// this.documentEditor.saveAsBlob('Docx').then((exportedDocument: Blob) => {

// send to server to return as string.
// let testContent = this.documentEditor.serialize();
this.documentEditor.saveAsBlob('Docx').then((exportedDocument: Blob) => {
// The blob can be processed further
// console.log('Test Content: ' + testContent);
 // saveAs(exportedDocument, 'test.docx');

// experiment to send to server with doc_id for template files
let formData = new FormData();
// let file = files[0];
let setFilename = "testFileCreated.docx";  // get real file name
let file = exportedDocument // need to establish
formData.append('selectFile', file, setFilename);
this.fileUploader.uploadDocxTemplateFiles(formData, 1).subscribe(
 //res=> this.dataLoaded(res)
res => { let data = res;
console.log('File Saved: ' + data);
// TODO: issue a notification upon save + error
}
);



});
}


public saveAsBlobSfdt() :void {
  let testContent = this.documentEditor.serialize();


  let http: XMLHttpRequest = new XMLHttpRequest();
  http.open('POST', this.gfunc.sopDocxServerURL + '/ExportSFDT');
  http.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
  http.responseType = 'json';
  let sfdt: any = { content: this.documentEditor.serialize() };
  http.send(JSON.stringify(sfdt));



  this.documentEditor.saveAsBlob('Sfdt').then((exportedDocument: Blob) => {
  // The blob can be processed further
   console.log('Test Content: ' + testContent);
   // saveAs(exportedDocument, 'test.docx');
  
  // experiment to send to server with doc_id for template files
  // send to server to return as string.
  let formData = new FormData();
  // let file = files[0];
  let setFilename = "testFileCreated.sfdt";  // get real file name
  let file = exportedDocument // need to establish
  formData.append('selectFile', file, setFilename);
  this.fileUploader.uploadDocxTemplateFiles(formData, 1).subscribe(
   //res=> this.dataLoaded(res)
  res => { let data = res;
  console.log('File Saved: ' + data);
  // TODO: issue a notification upon save + error
  }
  );



  });
  }




public saveAsSfdt() :void {
this.documentEditor.save('sample','Sfdt');
}

public saveAsDocx() :void {
this.documentEditor.save('sample','Docx');
}


// public uploadSaveDocx(doc_id): void {
// //this.elem.nativeElement.querySelector('#spinner').style.visibility='visible';
// // let files = this.elem.nativeElement.querySelector('#selectFile').files;
// let formData = new FormData();
// // let file = files[0];
// let file = this.selectedFileBlob // need to establish
// formData.append('selectFile', file, file.name);
// this.fileUploader.uploadDocxTemplateFiles(formData, doc_id).subscribe(res=> this.dataLoaded(res));
// }



@ViewChild('documenteditor_default')
  public container: DocumentEditorContainerComponent;
  // load your default document here
   onCreate(): any {
      let sfdt: string =`{"sections":[{"sectionFormat":{"pageWidth":612,"pageHeight":792,"leftMargin":72,"rightMargin":72,"topMargin":72,"bottomMargin":72,"differentFirstPage":false,"differentOddAndEvenPages":false,"headerDistance":36,"footerDistance":36,"bidi":false},"blocks":[{"paragraphFormat":{"afterSpacing":30,"styleName":"Heading 1","listFormat":{}},"characterFormat":{},"inlines":[{"characterFormat":{},"text":"Adventure Works Cycles"}]}],"headersFooters":{"header":{"blocks":[{"paragraphFormat":{"listFormat":{}},"characterFormat":{},"inlines":[]}]},"footer":{"blocks":[{"paragraphFormat":{"listFormat":{}},"characterFormat":{},"inlines":[]}]}}}],"characterFormat":{"bold":false,"italic":false,"fontSize":11,"fontFamily":"Calibri","underline":"None","strikethrough":"None","baselineAlignment":"Normal","highlightColor":"NoColor","fontColor":"empty","fontSizeBidi":11,"fontFamilyBidi":"Calibri","allCaps":false},"paragraphFormat":{"leftIndent":0,"rightIndent":0,"firstLineIndent":0,"textAlignment":"Left","beforeSpacing":0,"afterSpacing":0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","listFormat":{},"bidi":false},"defaultTabWidth":36,"trackChanges":false,"enforcement":false,"hashValue":"","saltValue":"","formatting":false,"protectionType":"NoProtection","dontUseHTMLParagraphAutoSpacing":false,"formFieldShading":true,"styles":[{"name":"Normal","type":"Paragraph","paragraphFormat":{"lineSpacing":1.149999976158142,"lineSpacingType":"Multiple","listFormat":{}},"characterFormat":{"fontFamily":"Calibri"},"next":"Normal"},{"name":"Default Paragraph Font","type":"Character","characterFormat":{}},{"name":"Heading 1 Char","type":"Character","characterFormat":{"fontSize":16,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Default Paragraph Font"},{"name":"Heading 1","type":"Paragraph","paragraphFormat":{"beforeSpacing":12,"afterSpacing":0,"outlineLevel":"Level1","listFormat":{}},"characterFormat":{"fontSize":16,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Normal","link":"Heading 1 Char","next":"Normal"},{"name":"Heading 2 Char","type":"Character","characterFormat":{"fontSize":13,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Default Paragraph Font"},{"name":"Heading 2","type":"Paragraph","paragraphFormat":{"beforeSpacing":2,"afterSpacing":6,"outlineLevel":"Level2","listFormat":{}},"characterFormat":{"fontSize":13,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Normal","link":"Heading 2 Char","next":"Normal"},{"name":"Heading 3","type":"Paragraph","paragraphFormat":{"leftIndent":0,"rightIndent":0,"firstLineIndent":0,"textAlignment":"Left","beforeSpacing":2,"afterSpacing":0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","outlineLevel":"Level3","listFormat":{}},"characterFormat":{"fontSize":12,"fontFamily":"Calibri Light","fontColor":"#1F3763"},"basedOn":"Normal","link":"Heading 3 Char","next":"Normal"},{"name":"Heading 3 Char","type":"Character","characterFormat":{"fontSize":12,"fontFamily":"Calibri Light","fontColor":"#1F3763"},"basedOn":"Default Paragraph Font"},{"name":"Heading 4","type":"Paragraph","paragraphFormat":{"leftIndent":0,"rightIndent":0,"firstLineIndent":0,"textAlignment":"Left","beforeSpacing":2,"afterSpacing":0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","outlineLevel":"Level4","listFormat":{}},"characterFormat":{"italic":true,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Normal","link":"Heading 4 Char","next":"Normal"},{"name":"Heading 4 Char","type":"Character","characterFormat":{"italic":true,"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Default Paragraph Font"},{"name":"Heading 5","type":"Paragraph","paragraphFormat":{"leftIndent":0,"rightIndent":0,"firstLineIndent":0,"textAlignment":"Left","beforeSpacing":2,"afterSpacing":0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","outlineLevel":"Level5","listFormat":{}},"characterFormat":{"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Normal","link":"Heading 5 Char","next":"Normal"},{"name":"Heading 5 Char","type":"Character","characterFormat":{"fontFamily":"Calibri Light","fontColor":"#2F5496"},"basedOn":"Default Paragraph Font"},{"name":"Heading 6","type":"Paragraph","paragraphFormat":{"leftIndent":0,"rightIndent":0,"firstLineIndent":0,"textAlignment":"Left","beforeSpacing":2,"afterSpacing":0,"lineSpacing":1.0791666507720947,"lineSpacingType":"Multiple","outlineLevel":"Level6","listFormat":{}},"characterFormat":{"fontFamily":"Calibri Light","fontColor":"#1F3763"},"basedOn":"Normal","link":"Heading 6 Char","next":"Normal"},{"name":"Heading 6 Char","type":"Character","characterFormat":{"fontFamily":"Calibri Light","fontColor":"#1F3763"},"basedOn":"Default Paragraph Font"}],"lists":[],"abstractLists":[],"comments":[],"revisions":[],"customXml":[]}`;
      // open the default document.
let loadFile = this.gfunc.baseUploadURL + "/test.sfdt";

// DID NOT LOAD CORRECTLY
this.http.get(this.gfunc.baseUploadURL + '/test.sfdt', { responseType: 'text' }).subscribe(data => {
// console.log('data', data);
// this.container.documentEditor.open(data);
});


this.http.get(this.gfunc.baseUploadURL + '/test.sfdt', { responseType: 'text' }).subscribe(data => {
console.log('data on load  as text...', data);
this.selectedFileData = data;
// let sfdt: string = data;
// this.container.documentEditor.open(sfdt);
//
});

    // Now loading by a function, will only work if live on server, not in a local environment
     this.container.documentEditor.open(this.selectedFileData);
  }























}
